import ApiClient from 'shared/lib/ApiClient';
import config from '../config';

export default new ApiClient(config);
